import React from "react";
import { Card, Typography, Box, IconButton, useTheme, useMediaQuery } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

interface DeviationPerformanceMobileProps {
month: number;
year: number;
ga_code: string;
tourCardData: any;
}

const DeviationPerformanceMobile: React.FC<DeviationPerformanceMobileProps> = ({
month,
year,
ga_code,
tourCardData,
}) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
const { user, summary } = tourCardData || {};
const latest = summary?.[0] || null;
const territoryName = user?.territory || "";
const deviationPercent = latest?.deviation_percentage ?? 0;
const totalDeviations = latest?.total_deviations ?? 0;
const approvedDeviations = latest?.approved_deviations ?? 0;
const approvedPercent =
  totalDeviations > 0
    ? Number(((approvedDeviations / totalDeviations) * 100).toFixed(1))
    : 0;

const minThreshold = user?.min_deviation_threshold ?? 0;
const maxThreshold = user?.max_deviation_threshold ?? 100;

// Convert API decimal to percentage
const deviationPercentageValue = deviationPercent * 100;

// Determine message
let message = "";
if (deviationPercentageValue < minThreshold) {
  message = "Doing Good!";
} else if (
  deviationPercentageValue >= minThreshold &&
  deviationPercentageValue <= maxThreshold
) {
  message = "Stay Focused.";
} else {
  message = "Pay Attention.";
}


  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "2px solid #2196f3",
        p: 2,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        bgcolor: "#fff",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ fontSize: "0.95rem", color: "#000" }}
        >
              {territoryName}
        </Typography>
        <IconButton size="small" sx={{ color: "#000" }}>
          {/* <DownloadIcon sx={{ fontSize: 20 }} /> */}
        </IconButton>
      </Box>

      <Typography variant="caption" color="text.secondary" display="block">
        This Month
      </Typography>

      {/* Content */}
      <Box display="flex" alignItems="center" justifyContent="space-between">
        {/* Left Section */}
        <Box>
          <Typography
            fontWeight={700}
            sx={{
              color: "#00b050",
              fontSize: "3rem",
              // lineHeight: 1,
            }}
          >
                    {deviationPercent}%
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 0.5,
                color: "-moz-initial",
              fontWeight: 600,
              fontSize: "1rem",
            }}
          >
                 {message}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Keep It Below {minThreshold}%.
          </Typography>
        </Box>

        {/* Right Section - Circular Progress */}
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          {/* Circular Chart */}
          <Box
            sx={{
              width: 100,
              height: 100,
              position: "relative",
            }}
          >
            <CircularProgressbarWithChildren
              value={approvedPercent}
              strokeWidth={10}
              styles={buildStyles({
                pathColor: "#00bcd4",
                trailColor: "#e0e0e0",
              })}
            >
              <Typography
                variant="body2"
                sx={{
                  textAlign: "center",
                  lineHeight: 1.2,
                  fontSize: "0.75rem",
                  fontWeight: 400,
                }}
              >
                <strong>Total</strong>
                <br />
                <Typography
                  component="span"
                  sx={{ fontWeight: 700, fontSize: "1.5rem" }}
                >
                 {totalDeviations}
                </Typography>
              </Typography>
            </CircularProgressbarWithChildren>

            {/* Approved Percent text inside top */}
            <Typography
              sx={{
                position: "absolute",
                top: 6,
                left: "50%",
                transform: "translateX(-50%)",
                color: "#00bcd4",
                fontSize: "0.75rem",
                fontWeight: 700,
                whiteSpace: "nowrap",
              }}
            >
              {approvedPercent}%
            </Typography>
          </Box>

          {/* Approved Label Below */}
          <Box
            display="flex"
            alignItems="center"
            gap={0.5}
            mt={1}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor: "#00bcd4",
              }}
            />
            <Typography variant="caption" sx={{ fontSize: "0.75rem", color: "#000" }}>
              Approved
            </Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default DeviationPerformanceMobile;